import { Entry } from '../Entry'

export function Entry20221004_2() {
  return (
    <Entry title="04/10/2022 - v3.2.7">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/13273/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
